import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState } from 'react';
import { connect, useStore, useDispatch } from 'react-redux';
import { createProspect } from '../src/state/actions';
import { capitalize, getFirstItemFromMap } from '../src/utils/helpers';
import Reserve from '../src/containers/Reserve';
import { jsx as _jsx } from "react/jsx-runtime";

var Home = function Home() {
  var _useState = useState({
    emailSent: false,
    feedback: {
      info: '',
      error: '',
      loading: false
    }
  }),
      localState = _useState[0],
      setLocalState = _useState[1];

  var dispatch = useDispatch();
  var store = useStore();

  var updateLocalState = function updateLocalState(updates) {
    var newState = _objectSpread(_objectSpread({}, localState), updates);

    setLocalState(newState);
  };

  var feedback = localState.feedback,
      emailSent = localState.emailSent;

  var handleFeedback = function handleFeedback(error, info, loading) {
    var _error$data;

    var text = typeof error === 'string' ? error : 'Something Went Wrong!';

    if (error !== null && error !== void 0 && (_error$data = error.data) !== null && _error$data !== void 0 && _error$data.message) {
      var message = error.data.message;
      text = message;
    }

    updateLocalState({
      feedback: {
        error: !info && capitalize(text),
        info: info,
        loading: loading
      }
    });
  };

  var submitProspect = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(username, email) {
      var _store$getState, _store$getState$prosp, items, loading, _getFirstItemFromMap, id;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              handleFeedback('', '', true);
              _context.next = 4;
              return createProspect({
                username: username,
                email: email
              })(dispatch);

            case 4:
              _store$getState = store.getState(), _store$getState$prosp = _store$getState.prospect, items = _store$getState$prosp.items, loading = _store$getState$prosp.loading;
              _getFirstItemFromMap = getFirstItemFromMap(items), id = _getFirstItemFromMap.id;
              updateLocalState({
                feedback: {
                  info: '',
                  error: '',
                  loading: loading
                },
                emailSent: id !== undefined
              });
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              handleFeedback(_context.t0, '', false);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    return function submitProspect(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_jsx(Reserve, {
    emailSent: emailSent,
    submitProspect: submitProspect,
    feedback: feedback,
    handleFeedback: handleFeedback
  });
};

var mapStateToProps = function mapStateToProps() {
  return {};
};

export default connect(mapStateToProps)(Home);